export enum OutputTypeEnums {
  URINE = "urine",
  BOWEL = "bowel",
  OTHER = "other",
}

export const outputTypeLabelMap: Record<string, string> = {
  [OutputTypeEnums.URINE]: "Urine",
  [OutputTypeEnums.BOWEL]: "Bowel",
  [OutputTypeEnums.OTHER]: "Other",
};

export const outputTypeOptions = Object.values(OutputTypeEnums).map(
  (value) => ({
    label: outputTypeLabelMap[value] || value,
    value,
  }),
);
